import { gql } from '@ori/fetching';

export const benefitBannerQuery = gql`
  fragment BenefitBanner on BenefitBanner {
    messageTitle
    messageUrl
  }

  query GetBenefitBanner {
    application {
      frontpage {
        benefitBanner {
          ...BenefitBanner
        }
      }
    }
  }
`;
